// extracted by mini-css-extract-plugin
module.exports = {"deleteButton":"EditPaymentMethodModal_deleteButton__1eGy8"};